import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addMandatorySubJobPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    //设置联动的Select
    getMandatorySubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
  }, config.setTimeoutMilliSecond);
}

export function editMandatorySubJobPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    //设置联动的Select
    getMandatorySubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
  }, config.setTimeoutMilliSecond);
}

///获取当前Group列表
export function getMandatorySubJobGroupSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Business/MandatorySubJobGroup/GetSelectOptionList?jobId=' + pageComponent.state.jobData.JobId)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        componentDataSource['GroupId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (parameter.GroupId === undefined || parameter.GroupId === null) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('GroupId', dataSource[0].Value);
        }
        const formRef = sectionComponent.customForm.current?.formRef.current;
        const currentMetaTypeId = formRef?.getFieldValue('MetaTypeId');
        // Group 下拉异步加载完成时只初始化空值，避免覆盖编辑表单已回填的 BAMS Type。
        if (formRef && (currentMetaTypeId === undefined || currentMetaTypeId === null)) {
          formRef.setFieldValue('MetaTypeId', 0);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//Inspection Name 快速选择
export function nameOnChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  parameter = parameter.replace(/#/g, '');
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&moduleId=' + pageComponent.state.moduleId)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((subJobType, j) => {
            options.push({ label: subJobType.Name, value: subJobType.Name, data: subJobType });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    let componentDataSource = { ...formComponent.state.componentDataSource };
    componentDataSource[uie.source] = [];
    formComponent.setState({ componentDataSource });
  }
}

//Inspection Name 选择后快速填写数据
export function nameOnSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('MetaTypeId', data.data.SubJobMetaTypeId !== null ? data.data.SubJobMetaTypeId : 0);
}

//打开从模板添加界面
export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let defaultFormData = pageComponent.state.defaultFormData;
  defaultFormData.moduleId = pageComponent.state.moduleId;
  pageComponent.setState({ defaultFormData });
  openAddFromTemplate({ component: pageComponent, parameter: parameter?.GroupId });
}

export function openAddFromTemplate({ component, parameter } = {}) {
  component.setState({ mandatorySubJobAddFromTemplateShow: true });
  component.mandatorySubJobAddFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.mandatorySubJobAddFromTemplate.current?.setState({ groupId: parameter });
    component.mandatorySubJobAddFromTemplate.current?.formRef.current?.resetFields();
    component.mandatorySubJobAddFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], subJobTypePresetContentList: [] });
    setTimeout(() => {
      component.mandatorySubJobAddFromTemplate.current?.additionalFormRef.current?.child.current?.getSubJobTypeData();
      component.mandatorySubJobAddFromTemplate.current?.getSubJobTypePresetDataSource();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function manageGroup({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageGroupShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.manageGroup.current?.getMandatorySubJobGroupList();
  }, config.setTimeoutMilliSecond);
}

export function addMandatorySubJob({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData, currentDataKey: 0 });

    setTimeout(() => {
      //设置联动的Select
      getMandatorySubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function showCopyMandatorySubJob({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mandatorySubJobCopyAlertShow: true });
}
